import { mockPrompts } from "../constants/prompts.mjs";
export const mockPromptResolver = (query, _) => {
  const resolved = mockPrompts.get(query.toLowerCase().trim());
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (resolved) {
        resolve(resolved);
      } else {
        console.error(`Unsupported query: ${query}`);
        reject(new Error('Could not process prompt'));
      }
    }, 1000);
  });
};